import { useCallback } from "react";
import { toast } from "sonner";
import { useEncounterHumanReviewMutations } from "../human-coding/useEncounterHumanReviewMutations";
import type { CodeItem } from "./codeComparison";

interface CreateReviewParams {
  encounterId: string;
  procedures: CodeItem[];
  diagnoses: CodeItem[];
}

export const useCreateHumanEncounterReview = () => {
  const { saveCodes } = useEncounterHumanReviewMutations();

  const createReview = useCallback(
    async ({ encounterId, procedures, diagnoses }: CreateReviewParams) => {
      // Convert CodeItem[] to FinalizeCodesData format
      const finalizeData = {
        encounterId,
        procedures: procedures.map((proc, index) => ({
          opcs_4_code: proc.code,
          description: proc.description || "",
          order_index: proc.orderIndex ?? index + 1,
        })),
        diagnoses: diagnoses.map((diag, index) => ({
          icd_10_code: diag.code,
          description: diag.description || "",
          order_index: diag.orderIndex ?? index + 1,
        })),
      };

      try {
        return await saveCodes.mutateAsync(finalizeData);
      } catch (error) {
        toast.error("Couldn't create the coding review. Please try again.");
        throw error;
      }
    },
    [saveCodes],
  );

  return {
    createReview,
    isPending: saveCodes.isPending,
    error: saveCodes.error,
  };
};
